import Accordion from 'accordion-js';

export function isAdmin() {
      if(typeof wp !== 'undefined') return true;
      return false;
    }

export function isLoggedInAdmin() {
      if(!isAdmin()) return false;
      if(!wp.hasOwnProperty('userSettings')) return false;
      if(wp.userSettings.uid > 0) return true;
      return false
    }

export function editorDatas(){
      if(isLoggedInAdmin()) return wp.data.select('core/editor');
      return false;
    }

export function currentPostId() {
      let postId = false;
      
      if(exists(themeLocals)) {
        if(exists(themeLocals.postId)) return onlyNumbers(themeLocals.postId);
      } 

      let datas = false;
      if(datas = editorDatas()) return onlyNumbers(datas.getCurrentPostId());
      
      document.body.classList.forEach(className=>{
          if(className.includes('page-id-')) postId = className.split('-')[2];
          if(postId) return onlyNumbers(postId);
      });

      return false;
    }

export function exists(el) {
      if(el === undefined || el === null) return false;
      if(el.length === 0) return false;
      return true;
    }

export function toggleClass(el,className) {
      if(!exists(el)) return false;
      if(el.classList.contains(className)) {
        el.classList.remove(className);
        return false;
      } else {  
        el.classList.add(className);
        return true;
      }
    }

export function toggleClasses(el,class1,class2) {

      if(!exists(el)) return false;
      if(el.classList.contains(class1)) {
        el.classList.add(class2);
        el.classList.remove(class1);
        return;
      } 
      if(el.classList.contains(class2)) {  
        el.classList.remove(class2);
        el.classList.add(class1);
        return;
      }
    }

export function toggleSiblings(el, siblings, className = themeLocals.activeClass) {
      if(!exists(el)) return;
      if(!exists(siblings)) return;
      siblings.forEach(sibling => {
          if(sibling != el) sibling.classList.remove(className);
      });

      toggleClass(el,className);
    }

export function createElement(tag, id = false, className = false, content = false) {
      let el = document.createElement(tag);
      if(id) el.id = id;
      if(className) el.classList.add(className);
      if(content) el.innerHTML = content;
      return el;
    }


export function moveToBody(el, prepend = false) {
      if (document.querySelector(`body #${el.id}`)) return;
      if (prepend) {
        document.body.prepend(el);
        return;
      }
      document.body.appendChild(el);
    }

export function wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }

export function fetchAjax(action, datas, nonce, callBack, that = null, beforeSend = false, complete = false) {

      const fetchDatas = new FormData();
      fetchDatas.append( 'action', action );
      fetchDatas.append( 'nonce', nonce );
      fetchDatas.append( 'datas', datas );


      const requestOptions = {
          method: 'POST',
          body: fetchDatas
      };
      
      beforeSend && beforeSend(that);
      
      fetch(themeLocals.url, requestOptions)
        .then(response => {
            if (!response.ok) {
                console.error(response);
                throw new Error(response.text());
            }
            return response.text();
        })
        .then(responseText => {
            callBack && callBack(responseText, datas, that); 
        })
        .catch(error => {
            console.error("Fetch error:", error);
        })
        .finally(() => {
            complete && complete(that);
      });

    }

export function onlyNumbers(e){//i.e.: clean html from counter or price elements
      return parseInt(e.replace(/[^0-9]/g,""));
    }

export function arraySearch(value, array) {
    
      for(var key in array) { 
        if(typeof(array[key]) == 'object') {
          if(array[key].includes(value)) return true;
        }
        if(typeof(array[key]) == 'string') {
          if(array[key] == value) return true;
        }
      }
      return false;

    }

export function scrollDirection() {
  
      document.addEventListener("DOMContentLoaded", function(event) {
    
        let lastScrollTop = 0;
        let scrollTop = window.scrollY;
        let offset = 80;
    
        window.addEventListener('load', (e) => {
          setTimeout(function(){
            scrollTop = window.scrollY;
            if(scrollTop <= offset) document.body.classList.add('scroll-offset');
    
            if(scrollTop > offset) {
                document.body.classList.add('scroll-up');
                document.body.classList.remove('scroll-down');
            }
          },500);
        });
        
        window.addEventListener('scroll', function(e) {
          scrollTop = window.scrollY;
    
          if (scrollTop > lastScrollTop ) {
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            
          } else {
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down'); 
          }
    
          if(scrollTop <= offset) {
            document.body.classList.add('scroll-offset');
          } else {
            document.body.classList.remove('scroll-offset');
          }
    
          lastScrollTop = scrollTop;
        });
     
      });
    
    }
    

export function copyToClipboard(selector = 'button.copy, .button.copy') {

      let buttons = document.querySelectorAll(selector);

      if(!exists(buttons)) return;
      
      buttons.forEach(button => {
          button.addEventListener('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            
            if(!this.dataset.value) return;
            
            let content = this.dataset.value;
            let parent = this.parentElement;
            let copyTextarea = document.createElement("textarea");
            copyTextarea.style.position = "fixed";
            copyTextarea.style.opacity = "0";
            copyTextarea.textContent = content;
        
            document.body.appendChild(copyTextarea);
            copyTextarea.select();
            document.execCommand("copy");//No replacement for this command
            parent.classList.add(themeLocals.activeClass);
            setTimeout(function(){
              parent.classList.remove(themeLocals.activeClass);
            },1000);
            document.body.removeChild(copyTextarea);
        });
      });
      
    }

export function cssComputedProperty(el, prop, compare = null) {
  
  if (!el) return false;
  const computedStyle = window.getComputedStyle(el);
  const propertyValue = computedStyle.getPropertyValue(prop);
  if (compare === null) return propertyValue;
  return propertyValue === compare;
}

export function setAccordions({//accordion-js does not work properly with custom selectors
  accordionSelector = null,
  itemsSelector = null,
  triggerSelector = null,
  panelSelector = null,
  reset = false,
}) {

  if(!exists(itemsSelector) || triggerSelector == null || panelSelector == null) return;
  const items = document.querySelectorAll(itemsSelector);
  if(!exists(items)) return;

  items.forEach(el => {//accordion-js does not work properly with custom selectors
  
      if(cssComputedProperty(el, 'display') == 'none') return;
      
      let trigger = el.querySelector(triggerSelector);
      let panel = el.querySelector(panelSelector);
      if(!exists(trigger) || !exists(panel)) return;

      if(!el.classList.contains('ac')) el.classList.add('ac');
      if(!trigger.classList.contains('ac-trigger')) trigger.classList.add('ac-trigger');
      if(!panel.classList.contains('ac-panel')) panel.classList.add('ac-panel');

      if(reset !== false) {
        el.classList.remove('ac');
        trigger.classList.remove('ac-trigger');
        panel.classList.remove('ac-panel');
      }
  });

  new Accordion(accordionSelector, {
    duration: 400,
    showMultiple: false,
  });
}

/**
 * 
 * @param el "HTMLElement"
 * @param viewportOrigin "%" | "100" | "0"
 * @param elOrigin "center" | "top" | "bottom"
 * @param tolerance "px"
 * @returns boolean
 */
export function isElementInViewport(el, viewportOrigin = 100, elOrigin = 'center', tolerance = 0) {
  if(!exists(el)) return false;

  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  viewportOrigin = viewportOrigin === 0 ? 0 : windowHeight * (viewportOrigin / 100);

  if(elOrigin === 'center') elOrigin = (rect.top + rect.bottom) / 2;
  if(elOrigin === 'top') elOrigin = rect.top;
  if(elOrigin === 'bottom') elOrigin = rect.bottom;
  if(Math.abs(elOrigin) < (windowHeight - viewportOrigin + tolerance)) return true;
  return false;
}

export function collapseAfterNElements(grid, items, collapseAfter = 1, collapseText = 'See more', breakpoint = 992, moveByColumns) {

  if(!grid) return;
  if(!items) return;

  if(!breakpoint) return;
  if(window.innerWidth > breakpoint) return;

  /* Check items to collapse */
  collapseAfter = parseInt(collapseAfter);
  if(items.length <= collapseAfter) return;
  if(collapseAfter === 0) collapseAfter = items.length;//Collapse all

  let itemsToCollapse = Array.from(items).slice(collapseAfter);
  if(!itemsToCollapse) return;

  if(moveByColumns) {
    let parents = [];
    itemsToCollapse.forEach(itemToCollapse => {
      let parent = itemToCollapse.parentElement;
      if(!parent) return;
      if(arraySearch(parent, parents)) return;
      parents = [...parents, parent];
    });

    let itemsToCollapse = parents;
  }

  /* Create accordion */
  const accordionSelector = 'accordion';
  const itemsSelector = 'ac';
  const triggerSelector = 'ac-trigger';
  const panelSelector ='ac-panel';

  let accordion = createElement('div', false, accordionSelector);
  let item = createElement('div', false, itemsSelector);
  let title = createElement('div', false, triggerSelector);
  let titleText = createElement('span', false, false, collapseText.toString());
  let content = createElement('div', false, panelSelector);
  
  itemsToCollapse.forEach(itemToCollapse => {
      content.appendChild(itemToCollapse);
  });

  title.appendChild(titleText);
  item.append(title);
  item.append(content);
  accordion.append(item);

  grid.append(accordion);

  new Accordion('#' + grid.id + ' .'+accordionSelector, {
      duration: 400,
      showMultiple: false,
      collapse: true,
  });

  /* Clean empty columns and adjust css */
  if(!moveByColumns) cleanEmptyCols(grid);
  if(accordion.previousElementSibling) {
    accordion.previousElementSibling.classList.add('mb-0');//Remove margin bottom on preceding element
  }
}

export function cleanEmptyCols(grid) {
  const cols = grid.querySelectorAll('div');
  if(!cols) return;
  cols.forEach(col => {
    const classes = col.className.split(' ');
    if (!classes.some(cls => cls.includes('col'))) return;
    if (col.innerHTML.trim() === '')  col.remove();
  });
}

export function extendLinkToItem(selector) {
  document.addEventListener("DOMContentLoaded", function(event) {
    const items = document.querySelectorAll(selector);
    if(!items) return;
    items.forEach(item => {
      const link = item.querySelector('a');
      if(!link) return;
      const url = link.getAttribute('href');
      if(!url) return;
      item.classList.add('clickable');
      item.addEventListener('click', function(e) {
        window.location.href = url;
      });

    });
  });
}

export function setResponsiveFonts(selector = '.responsive-font', fontFactor = 1.2, lineHeightFactor = 1.5, min = 0, max = 1200) {
  
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll(selector);
    if(!elements) return;
    
    var windowWidth = window.innerWidth;
    max = 0 === max ? windowWidth : max;
    if(windowWidth >= min && windowWidth <= max) {
      elements.forEach((element) => {
            setFontSize(element, fontFactor, lineHeightFactor);
      });
    } else {
      elements.forEach((element) => {
        unsetFontSize(element);
      });
    }


    window.addEventListener('resize', () => {
      
      var windowWidth = window.innerWidth;
      max = 0 === max ? windowWidth : max;
      if(windowWidth >= min && windowWidth <= max) {
        elements.forEach((element) => {
          setFontSize(element, fontFactor, lineHeightFactor);
        });
      } else {
        elements.forEach((element) => {
          unsetFontSize(element);
        });
      }
    });
  });

}

function setFontSize(element, fontFactor, lineHeightFactor) {
  let fontSize = calculateFontSize(element, fontFactor);
  let content = element.querySelectorAll('a, li, p, ul');
  element.style.fontSize = `${fontSize}px`;
  element.style.lineHeight = `${Math.round(fontSize * lineHeightFactor)}px`;
  if(!content) return;
  content.forEach((childEl) => {
      childEl.style.fontSize = `${fontSize}px`;
      childEl.style.lineHeight = `${Math.round(fontSize * lineHeightFactor)}px`;
  });
}

function calculateFontSize(element, fontFactor) {
  let rect = element.getBoundingClientRect();
  let computedStyles = window.getComputedStyle(element);
  let paddingsY = parseInt(computedStyles.paddingTop) + parseInt(computedStyles.paddingBottom);
  let paddingsX = parseInt(computedStyles.paddingLeft) + parseInt(computedStyles.paddingRight);
  
  let gutterY = paddingsY ? paddingsY * rect.width : 0;
  let gutterX = paddingsX ? paddingsX * rect.height : 0;
  let pixels = (rect.width * rect.height) - gutterY - gutterX;
  let characters =  element.innerText.length;
  let ratio = pixels / characters;
  let height = Math.sqrt(ratio);
  let fontSize = Math.round(height / fontFactor);
  return fontSize;
}

function unsetFontSize(element) {
  element.style.fontSize = '';
  element.style.lineHeight = '';
  let content = element.querySelectorAll('a, li, p, ul');
  if(!content) return;
  content.forEach((childEl) => {
      childEl.style.fontSize = '';
      childEl.style.lineHeight = '';
  });
}